$(() => {
    initFunctions();
});

function initFunctions() {
    startSliders();
}

function startSliders() {
    startHeroSlider();
    startUspSlider();
}

let heroInterval = null;
let uspInterval = null;

function startHeroSlider() {
    let slider = $('.slider');
    if (!slider[0]) return;

    let intervalTimer = 8200;
    heroInterval = setInterval(function() {
        let continueLooping = nextSlide('.slider', 'fadingOut');
        if (!continueLooping) {
            clearInterval(heroInterval);
        }
    }, intervalTimer);
}

function startUspSlider() {
    let slider = $('.usp-slider');
    if ((!slider[0]) || ($(document).width() > 991)) return;

    let intervalTimer = 8200;
    uspInterval = setInterval(function() {
        let continueLooping = nextSlide('.usp-slider', 'slideLeft');
        if (!continueLooping) {
            clearInterval(uspInterval);
        }
    }, intervalTimer);
}

function nextSlide(sliderSelector, fadeClass) {
    let slider = $(sliderSelector);
    let activeClass = 'active';
    let fadeSpeed = 1800;

    let slides = slider.find('.slide');
    let lastSlide = slides.length;

    let activeSlide = slider.find('.active')[0];
    if (!activeSlide || !activeSlide.id) {
        return false; // Stop the interval
    }

    let active = parseInt(activeSlide.id.replace(/[^0-9]/gi, ''));
    let next = active + 1;
    if (next > lastSlide) next = 1;

    $(sliderSelector + ' #slide-' + next).addClass(activeClass);
    $(sliderSelector + ' #slide-' + active).addClass(fadeClass);
    setTimeout(() => {
        $(sliderSelector + ' #slide-' + active).removeClass(fadeClass).removeClass(activeClass);
    }, fadeSpeed);

    return true;
}
